<template>
  <div class="vuestic-pre-loader">
    <img src="../../../assets/fractel/spinner.svg"/>
    <p v-if="total > 0" class="vuestic-pre-loader loader-text text-center">{{current}} of {{total}} completed</p>
  </div>
</template>

<script>
  export default {
    name: 'vuestic-pre-loader',
    methods: {},
    mounted () {},
    props: {
      total: {
        type: Number,
        default: 0
      },
      current: {
        type: Number,
        default: 0
      }
    },
    data: function () {
      return {}
    }
  }
</script>
<style lang="scss">
@import "../../../sass/_variables.scss";

.loader-text {
  color: white;
  background-color: $fractel-teal;
  border-radius: 5px;
}

.vuestic-pre-loader {
  margin-top: 4rem;
}
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-preloader/VuesticPreLoader.vue